export default __webpack_public_path__ + "static/zento-bca28dd24cf6b65794140b5854d503b3.jpg";